import { JuloUpdateEntry } from "./types"

export const veckonummerManadsvyEntry: JuloUpdateEntry = {
  slug: "2026-05-13-veckonummer-manadsvy",
  date: "2026-05-13",
  title: "Veckonummer i månadens listvy",
  description:
    "Nu visas veckonummer även i månadens listvy, både i den lilla kalendern på sidan och i den kompakta vyn på surfplatta. Tidigare fanns veckonumren bara i rutnätsvyn.",
  images: [
    {
      src: "/julo-updates/2026-05-13-veckonummer-manadsvy/manadsvy.png",
      alt: "Månadens listvy med en ny vänsterkolumn märkt ”v.” som visar veckonummer (14, 15, 16, 17, 18) för varje rad i den lilla kalendern.",
    },
  ],
}
